import axios from '@/allotment/axios'

export default {
  upload: file => axios.post('/file/info/upload', { file }, { headers: { 'Content-Type': 'multipart/form-data' } }), //文件上传
  page: data => axios.post('/file/info/select/page', data), //文件分页查询
  delete: id => axios.post('/file/info/update/status', { id }), //文件分页查询
  download: id => axios.get(`/file/info/download/${id}`, { responseType: 'blob' }), //文件下载

  fileGroupTree: () => axios.get('/file/group/tree'), //文件分组树查询
  fileGroupSave: data => axios.post('/file/group/save', data), //文件分组保存
  fileGroupDelete: id => axios.get(`/file/group/delete/${id}`), //文件分组删除

  filePage: data => axios.post('/file/group/info/select/page', data), //文件分组分页查询
  fileSave: data => axios.post('/file/group/info/save', data), //文件分组保存
  fileDownload: id => axios.get(`/file/group/info/download/${id}`, { notbody: true, responseType: 'blob', timeout: 10 * 60000 }), //文件分组下载
  fileDelete: id => axios.get(`/file/group/info/delete/${id}`) //文件分组删除
}
